<script>
  import { useAnalytics } from "./analytics";
  import ArrowDown from "./ArrowDown.svelte";
</script>

<img src="/resources/images/app.png" alt="App" class="appImage"/>

<div class="container">
  <div class="additional-info">
    <p>
      <b>Bringflow is a tool for leaders, managers, therapists, advisors, and anyone involved in planning the meetings and following up on further conclusions.</b>
    </p>

    <div class="imagePanel">
      <img src="/resources/images/activity_team_work.svg" alt="Image">
      <p>You will keep your work under control. Bringflow is like your personal assistant that will remind you of what you have to do, encourage you to summarize your meetings, and ask you to plan new events when necessary.</p>
    </div>

    <div class="imagePanel imagePanelReversed">
      <img src="/resources/images/activity_taking_notes.svg" alt="Image">
      <p>Bringflow will help you form good habits of planning your work proactively and building your knowledge-base of all the important things you work on. What you learn will be safely stored, accessible, and ready to use in the future.</p>
    </div>

    <div class="imagePanel">
      <img src="/resources/images/activity_timeline.svg" alt="Image">
      <p>You might have busy days when you jump from meeting to meeting, and your to-do list is piling up. Bringflow will quickly prove its value by making all those activities more approachable and manageable for you.</p>
    </div>

    <div class="imagePanel imagePanelReversed">
      <img src="/resources/images/activity_checking.svg" alt="Image">
      <p>The idea of Bringflow was born out of the belief that management success results from cultivating good, well-thought habits that make the work-life more organized and predictable.</p>
    </div>
  </div>

  <a href="https://app.bringflow.com/register" class="button is-primary is-large" data-action="SignUp" data-label="Content-initial" on:click={useAnalytics}>Sign up for free</a>
  <ArrowDown/>

  <section>
    <div class="section-title">Start today</div>
    <div class="section-subtitle">Get organized</div>
  </section>

  <div class="features">
    <div class="columns">
      <div class="column features-text">
        <div class="features-icon material-icons">event</div>
        <div class="features-name">Plan meetings</div>
        <div class="features-value">Plan new meetings and write agendas</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">event_note</div>
        <div class="features-name">Write meeting notes</div>
        <div class="features-value">Summarize the meeting</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">fact_check</div>
        <div class="features-name">Add action points</div>
        <div class="features-value">Add to-dos and follow them up after meetings</div>
      </div>
    </div>
    <div class="columns">
      <div class="column features-text">
        <div class="features-icon material-icons">loop</div>
        <div class="features-name">Use recurring meetings</div>
        <div class="features-value">Set up recurring meetings and get reminders to plan them</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">directions</div>
        <div class="features-name">Get guidance</div>
        <div class="features-value">Get reminders to summarize the meetings in a best way</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">emoji_objects</div>
        <div class="features-name">Browse knowledge base</div>
        <div class="features-value">Use the existing notes as a reference for the new meetings</div>
      </div>
    </div>
    <div class="columns">
      <div class="column features-text">
        <div class="features-icon material-icons">local_offer</div>
        <div class="features-name">Organize with tags</div>
        <div class="features-value">Tags will help to quickly find what you need</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">content_copy</div>
        <div class="features-name">Use templates</div>
        <div class="features-value">Reuse agenda points for similar meetings</div>
      </div>
      <div class="column features-text">
        <div class="features-icon material-icons">thumb_up</div>
        <div class="features-name">Follow best practices</div>
        <div class="features-value">Get tips for writing good summaries and action points</div>
      </div>
    </div>
  </div>

  <ArrowDown/>

  <section>
    <div class="section-title">Let's start!</div>
    <div class="section-subtitle sign-up-subtitle">After signing up you will go through the onboarding to see basic use cases and create your workspace.</div>
  </section>

  <a href="https://app.bringflow.com/register" class="button is-primary is-large" data-action="SignUp" data-label="Content-bottom" on:click={useAnalytics}>Sign up for free</a>
</div>

<style>
  .container {
    padding: 60px 0;
    text-align: center;
    border-radius: 15px;
    background-color: #fff;
  }

  section {
    margin-bottom: 40px;
  }

  .section-title {
    font-size: 32px;
    font-weight: 600;
  }

  .section-subtitle {
    font-size: 25px;
    text-align: center;
    color: #7b7b7b;
  }

  .features {
    margin-bottom: 40px;
  }

  .features-text {
    padding: 50px 20px;
    border-right: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    transition: background-color linear 0.5s;
    cursor: default;
  }

  .features-text:hover {
    background-color: #f8f8f8;
  }

  .features .columns {
    margin-left: 0;
    margin-right: 0;
  }

  .features .columns .features-text:last-child {
    border-right: none;
  }

  .features .columns:last-child .features-text {
    border-bottom: none;
  }

  .features-icon {
    display: inline-flex;
    margin-bottom: 20px;
    font-size: 40px;
  }

  .features-name {
    font-weight: 600;
    font-size: 24px;
  }

  p {
    font-size: 20px;
    line-height: 1.5;
    max-width: 840px;
    margin: 0 auto 50px;
  }

  .additional-info {
    margin-bottom: 60px;
  }

  .sign-up-subtitle {
    max-width: 570px;
    margin: 0 auto;
  }

  .button {
    min-width: 300px;
  }

  .appImage {
    display: block;
    margin: 0 auto;
    width: 1135px;
    box-shadow: #0003 0 0 6px;
    border-radius: 12px;
  }

  .imagePanel {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
  }

  .imagePanel img {
    width: 140px;
    height: 120px;
  }

  .imagePanel p {
    display: block;
    width: 550px;
    margin: 0 0 0 80px;
  }

  .imagePanelReversed {
    margin-left: auto;
    flex-direction: row-reverse;
  }

  .imagePanelReversed p {
    margin: 0 80px 0 0;
  }

  .noPaid {
    margin-top: 6px;
    color: #00000096;
  }

  @media screen and (max-width: 899.5px) {
    .features-text {
      border-right: none;
    }

    .features .columns:last-child .features-text {
      border-bottom: 1px solid #eaeaea;
    }

    .features .columns:last-child .features-text:last-child {
      border-bottom: none;
    }

    p {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 599.5px) {
    .imagePanel {
      flex-direction: column;
      align-items: center;
    }

    .imagePanel img {
      margin-bottom: 50px;
    }

    .imagePanel p {
      width: 100%;
      margin: 0;
    }

    .imagePanelReversed {
      margin-left: 0;
      flex-direction: column;
    }

    .imagePanelReversed p {
      margin: 0;
    }
  }
</style>
